import { render, staticRenderFns } from "./createPhoto.vue?vue&type=template&id=469812aa&scoped=true&"
import script from "./createPhoto.vue?vue&type=script&lang=js&"
export * from "./createPhoto.vue?vue&type=script&lang=js&"
import style0 from "./createPhoto.vue?vue&type=style&index=0&id=469812aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469812aa",
  null
  
)

export default component.exports